import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { env, STORAGE_PREFIX } from '../../config/env';

/**
 * Cliente de Supabase compartido por toda la aplicación (Singleton).
 *
 * Un único punto de creación evita el problema de la versión anterior, donde
 * convivían dos capas de acceso a datos y el cliente llegaba a parchearse en
 * caliente para filtrar resultados.
 *
 * Si algún día hace falta alterar el comportamiento de las consultas (por
 * ejemplo ocultar un cliente concreto), se hace decorando los repositorios,
 * nunca modificando este objeto.
 */
class ProveedorSupabase {
  private static instancia: SupabaseClient | null = null;

  static obtener(): SupabaseClient {
    if (!ProveedorSupabase.instancia) {
      ProveedorSupabase.instancia = createClient(env.supabase.url, env.supabase.anonKey, {
        auth: {
          // La sesión vive en el almacenamiento del navegador bajo un prefijo
          // propio, para poder limpiarla sin tocar datos de otras aplicaciones.
          storageKey: `${STORAGE_PREFIX}auth`,
          persistSession: true,
          autoRefreshToken: true,
          // Necesario para el flujo de recuperación de contraseña, que llega
          // con el token en el fragmento de la URL.
          detectSessionInUrl: true,
          flowType: 'pkce',
        },
        realtime: {
          params: { eventsPerSecond: 10 },
        },
        /*
         * Aquí NO se añaden cabeceras propias.
         *
         * Hubo una `x-application-name` para identificar la aplicación en los
         * registros, y rompía todas las Edge Functions: cada función declara
         * qué cabeceras admite, las que ya existían no conocían esa, y el
         * navegador cancelaba la petición en la comprobación previa. El fallo
         * aparecía como «Failed to send a request to the Edge Function», que no
         * apunta a la cabecera por ningún lado.
         *
         * Cualquier cabecera nueva obliga a repasar todas las funciones, así
         * que no sale a cuenta salvo que sea imprescindible.
         */
      });
    }
    return ProveedorSupabase.instancia;
  }
}

export const supabase = ProveedorSupabase.obtener();
